export const PLAN_BENEFITS = [
  "Platinum Members receive a +1% yield bonus on all liquidation orders",
  "Early Access to New Regions",
  "Reduced Transaction Fees",
  "Exclusive Eligibility for NFT Airdrops ",
  "Advanced Market Analytics",
  "VIP Investment Opportunities",
];

export const EMAIL_REGEX = /^[\w.%+-]+@[\w.-]+\.(com|org|net|io)$/i;
export const PLACEHOLDER_IMG =
  "https://lh3.googleusercontent.com/proxy/rnI3_En64EP7f3eLxeUK59zazrOt3DPuEhk8NOfOY_jdK7VbA7ucKFfwPTqdi_wFZCDyEWJ7hDnZq6D-94CPn7Qlp3A8tmPuWmJZf4aO3kbPtBnKfwVtZw";
